import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { deleterDispatchHelper } from 'actions/DeleterActions';

import ClientListInfo from 'components/layout/ClientListInfo';
import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import SimplePrompt from 'components/layout/SimplePrompt';

import List from 'components/List';

import ClientNew from 'components/modals/ClientNew';

import may from 'js/security';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import ClientBreadcrumbs from './Clients/Breadcrumbs';
import axios from "axios";

class Clients extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
      undeletingUsernames: [],
    };
  }

  // change the url to display client information
  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;

    return (
      <Breadcrumb
        crumbs={[{ link: appIntl.urlPrefix + 'account', name: 'Dashboard' }, { link: null, name: messages.clients }]}
        className="p-t-0"
      />
    );
  };

  handleRemoveClick = (e, clientId) => {
    e.preventDefault();
    e.stopPropagation();

    const { deleteClient } = this.props;
    deleteClient(clientId);
  };

  handleUndeleteClick = (e, clientId) => {
    const { undeletedUser } = this.props;
    const { undeletingUsernames } = this.state;
    e.preventDefault();
    e.stopPropagation();

    axios({
      method: 'put',
      url: `/api/clients/${clientId}/undelete.json`,
      data: { isDeleted: false },
    })
      .then(({ is_deleted: isDeleted }) => {
        // destructuring assignment to a list.data.list with a default to an empty array, no errors thrown
        const { list: { data: { list = [] } = {} } = {} } = this.props;
        const user = list.find(({ username }) => username === clientId);
        if (user && user.is_deleted !== isDeleted) {
          undeletedUser(clientId); // dispatches action to update the state list
          // remove the successfully undeleted username from the list
          this.setState({ undeletingUsernames: undeletingUsernames.filter(({ username }) => username !== clientId) });
        }
      })
      .catch(console.error);

    // add the username being undeleted to the list
    this.setState({ undeletingUsernames: [...new Set([...undeletingUsernames, clientId])] });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      location,
      user,
    } = this.props;
    const { showNew, undeletingUsernames } = this.state;

    const defaultParent = user.ancestors?.length ? user.ancestors.slice().pop() : user.username;
    const searchParams = new URLSearchParams(location.search);
    const parent = searchParams.get('filter[parent]') || defaultParent;
    const columns = [messages.client, messages.actions];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const client = list.data.list[i];
      const { username, is_active: isActive, is_deleted: isDeleted } = client;

      const detailsUrl = appIntl.urlPrefix + 'account/clients/' + username;

      tBody.push(
        <tr key={i} class="clickable" onClick={() => !isDeleted && this.handleRowClick(detailsUrl)}>
          <td class="v-align-middle">
            <ClientListInfo client={client} />
          </td>
          <td class="v-align-middle text-right">
            {may('ROLE_ADMIN', user.roles) &&
            (isDeleted ? (
              <>
                <SimplePrompt
                  bsStyle="info"
                  buttonLabel={messages.undelete}
                  iconClass="fa fa-trash-undo"
                  showMessage={messages.undelete_user_confirm}
                  onSuccess={e => this.handleUndeleteClick(e, username)}
                  disabled={undeletingUsernames.includes(username)}
                />
              </>
            ) : (
              <>
                <Link to={detailsUrl} class="btn-rounded m-r-10 btn btn-sm btn-default">
                  <i class="fa fa-pencil-alt" /> {messages.edit}
                </Link>

                <SimplePrompt
                  onSuccess={e => {
                    this.handleRemoveClick(e, username);
                  }}
                />
              </>
            ))}
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map(column => {
              return (
                <th key={column} class={column === messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <DocMeta tags={generateMetaTags(messages.meta.clients)}>
        <List
          listName="clients"
          url="/api/clients.json"
          urlData={{ filters: { type: 'company', parent } }}
          list={list}
          title={messages.clients}
          iconClass="fa fa-male"
          showNew
          newText={messages.add_client}
          newAction={this.showNew}
          showSearch
          sortOptions={['relevance,desc', 'username,asc', 'lastName,asc']}
          breadcrumb={this.getBreadcrumb()}
        >
          <ClientBreadcrumbs parent={parent} />

          {resultTable}

          <div id="client-new">
            <ClientNew show={showNew} close={this.closeNew} />
          </div>
        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.clients,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteClient: clientId => {
      deleterDispatchHelper('client', '/api/clients/' + clientId + '.json', dispatch);
    },
    undeletedClient: username => dispatch({ type: 'UNDELETED_CLIENT', payload: { username } }),
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Clients)
  )
);
